// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t1-2";
export var container = "_t1-4";
export var dismissButton = "_t1-3";
export var hasPaddingBottom = "_t1-6";
export var last = "_t1-e";
export var scrollbarThumb = "_t1-c";
export var scrollbarTrack = "_t1-b";
export var selected = "_t1-9";
export var spin = "_t1-1";
export var spinning = "_t1-0";
export var suggestionItem = "_t1-d";
export var suggestionsPanel = "_t1-5";
export var tonePill = "_t1-8";
export var tonesContainer = "_t1-7";
export var unselected = "_t1-a";